import {action} from 'easy-peasy';

export default {
  ignoreA2HS: !!localStorage.getItem('ignoreA2HS'),

  setIgnoreA2HS: action((state, ignoreA2HS) => {
    state.ignoreA2HS = ignoreA2HS;
  }),
};
